import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "loading-background" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

import { reactive } from "vue";
import LoadingDots from "./LoadingDots.vue";
import { loadingTexts } from "@/common/util";


export default /*@__PURE__*/_defineComponent({
  __name: 'LoadingDownloadScreen',
  setup(__props) {

const max = loadingTexts.length;
const state = reactive({
    iteration: 0,
    text: "Please do not leave this window",
    text2: loadingTexts[getRandomInt(max)]
})

setInterval(() => {
    const id = getRandomInt(max);
    if (state.iteration % 2 != 0) {
        state.text2 = loadingTexts[id]
    }
    state.iteration++;
}, 5000)

function getRandomInt(max: number) {
    return Math.floor(Math.random() * max);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_Transition, { name: "slide-fade" }, {
        default: _withCtx(() => [
          (state.iteration % 2 == 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(state.text), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(state.text2), 1))
        ]),
        _: 1
      }),
      _createVNode(LoadingDots, { class: "loading" })
    ])
  ]))
}
}

})